import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Switch, FormControlLabel } from '@material-ui/core';

const SettingsSwitch = withStyles((theme) => ({
  formControlLabel: {
    margin: '4px 0',
  },
  root: {
    width: 50,
    height: 30,
    padding: 0,
  },
  switchBase: {
    padding: 0,
    marginLeft: 3,
    marginTop: 3,
    '&$checked': {
      transform: 'translateX(20px)',
      color: `${theme.palette.common.white} !important`,
      '& + $track': {
        backgroundColor: '#06c2de',
        borderColor: 'transparent',
        opacity: 1,
      },
      '&& $thumb': {
        color: '#fff',
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
    color: '#06c2de',
  },
  track: {
    borderRadius: 99,
    border: `1px solid #ced4da`,
    backgroundColor: '#f8f9fa',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, label, ...props }) => (
  <FormControlLabel
    className={classes.formControlLabel}
    label={label ?? ''}
    control={
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    }
  />
));

export default SettingsSwitch;
